// eslint-disable-next-line jira/import/no-restricted-import
import { getProjectViewResources } from '@jira/router-resources__business-common/src/getBusinessProjectResources.tsx';
import { summaryBusinessEmbedEntrypoint } from '@jira/spa-apps__summary/src/summaryBusinessEmbedEntrypoint.entrypoint.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { ThemedLazySkeleton } from '@jira/platform__project-theme-components/src/ui/ThemedLazySkeleton.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { jiraBusinessSummaryEmbedRoute } from '@jira/router-routes__business-summary-routes/src/jiraBusinessSummaryEmbedRoute.tsx';
import { fetchAtlassianAccountTraitsResource } from '@jira/router-resources__contextual-summary/src/fetchAtlassianAccountTraitsResource.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import type { Route } from '@atlassian/react-resource-router';

const getRecommendationResources = () =>
	expVal('jira_agentic_summary_view', 'isEnabled', false)
		? [fetchAtlassianAccountTraitsResource]
		: [];

const summaryEmbedBusimessPageEntrypoint = createChromelessEntryPoint({
	main: summaryBusinessEmbedEntrypoint,
});

export const jiraBusinessSummaryEmbedRouteEntry: Route = createEntry(
	jiraBusinessSummaryEmbedRoute,
	() => ({
		group: 'classic-business',
		ufoName: 'jwm.summary-view-embed',
		layout: chromelessLayout,
		skeleton: ThemedLazySkeleton,
		resources: [...getProjectViewResources(), ...getRecommendationResources()],
		supportsProjectTheme: 'full',
		entryPoint: () => {
			return summaryEmbedBusimessPageEntrypoint;
		},
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
